export const experienceData = [
    {
        id: 1,
        company: 'Excel Mec',
        jobtitle: 'Frontend Developer',
        startYear: 'May 2022',
        endYear: 'Present'
    },
    /*{
        id: 2,
        company: 'Vehement Capital Partners',
        jobtitle: 'Backend Developer',
        startYear: '2019',
        endYear: '2020'
    },
    {
        id: 3,
        company: 'Wonka Industries',
        jobtitle: 'Marketing',
        startYear: '2020',
        endYear: 'Present'
    },*/
]